module.exports = __webpack_public_path__ + "static/media/save_ghost.27dff1c1.svg";